import React from 'react';
import { useAtom } from 'jotai';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    List,
    ListItem,
    ListItemText,
    IconButton,
    Stack,
    Box,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

import { cheatsheetAtom } from 'atoms/cheatsheetAtom';
import { SHORTCUTS } from 'utils/hooks/shortcutDefs';

// キー表記を <kbd> 風のチップで表示する（装飾のみ）。
const KeyCap: React.FC<{ label: string }> = ({ label }) => (
    <Box
        component="kbd"
        sx={{
            px: 0.75,
            py: 0.25,
            minWidth: 24,
            textAlign: 'center',
            fontFamily: 'inherit',
            fontSize: '0.75rem',
            fontWeight: 600,
            border: '1px solid',
            borderColor: 'divider',
            borderRadius: 1,
            bgcolor: 'action.hover',
        }}
    >
        {label}
    </Box>
);

// `?` キー／ヘルプメニューから開くショートカット一覧。表示専用（既存アクションの説明のみ）。
export const ShortcutCheatsheet: React.FC = () => {
    const [open, setOpen] = useAtom(cheatsheetAtom);
    const close = () => setOpen(false);

    return (
        <Dialog open={open} onClose={close} maxWidth="xs" fullWidth aria-labelledby="shortcut-cheatsheet-title">
            <DialogTitle
                id="shortcut-cheatsheet-title"
                sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', pr: 1 }}
            >
                キーボードショートカット
                <IconButton aria-label="閉じる" onClick={close} size="small">
                    <CloseIcon fontSize="small" />
                </IconButton>
            </DialogTitle>
            <DialogContent>
                <List dense disablePadding>
                    {SHORTCUTS.map((s) => (
                        <ListItem
                            key={s.id}
                            disableGutters
                            secondaryAction={
                                <Stack direction="row" spacing={0.5}>
                                    {s.keys.map((k) => (
                                        <KeyCap key={k} label={k} />
                                    ))}
                                </Stack>
                            }
                        >
                            <ListItemText primary={s.label} />
                        </ListItem>
                    ))}
                </List>
            </DialogContent>
        </Dialog>
    );
};
